import React from "react";
import Default280 from "../assets/img/common/img_posterDefault_280.jpg";

export const imgOnError = (e) => {
  e.target.src = Default280;
};
